import l10n from "../../../lang/locallang";
import {deleteErrorMessage, showErrorMessage} from "../../../assessments/CreateAssessmentHelpers";


export default class AssessmentMultipleResponsePublic {

    // Escape text before it goes into an HTML attribute so embedded quotes
    // don't truncate data-answer (which breaks answer matching against the backend)
    escapeHtml(text) {
        const map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;'
        };
        return text ? String(text).replace(/[&<>"']/g, m => map[m]) : '';
    }

    // Shuffle an array is using the Fisher-Yates algorithm
    shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }

    view(data, popup) {
        const {correctStatus, answers, your, choices} = l10n.customCourse;
        let items = ``;
        if (data.content) {
            this.shuffleArray(data.content);
            for (const [key, value] of Object.entries(data.content)) {
                items += `<li class="choice__item">
                    <div class="choice__your-answer">
                        <input
                            type="checkbox"
                            id="assessment-multiple-${key}"
                            value="${key}"
                            name="assessment-multiple"
                            class="choice__input"
                            data-answer="${this.escapeHtml(value.element)}"
                        >
                        <span class="choice__input-icon"></span>
                    </div>
                    <div class="choice__correct-answer is-hidden">
                        <span class="choice__input-icon"></span>
                    </div>
                    <label class="choice__label" for="assessment-multiple-${key}">${this.escapeHtml(value.element)}</label>
                </li>`;
            }
        }

        return `
            <div class="choice">
                <div class="choice__header">
                    <p class="choice__header-item is-your-answer">${your}<br>${answers}</p>
                    <p class="choice__header-item is-correct-answer is-hidden">${correctStatus}<br>${answers}</p>
                </div>
                <ul class="choice__list">
                    ${items}
                </ul>
            </div>
        `;
    }

    checkError() {
        let result = true;
        let popup = document.querySelector('#take-assessment-popup');
        const elements_count = popup.querySelectorAll('.choice__item').length;
        const elements_checked = popup.querySelectorAll('.choice__input:checked').length;
        const { errorMessage } = l10n.assessmentMultipleResponse;

        // if exists error message remove it
        deleteErrorMessage(popup);

        if (elements_checked === 0) {
            showErrorMessage(popup, errorMessage);
            result = false;
        }

        return result;
    }

    addAnswersList() {
        let popup = document.querySelector('#take-assessment-popup');
        let answers = [];
        popup.querySelectorAll('.choice__input:checked').forEach((item) => {
            answers.push(item.dataset.answer);
        });

        return answers;
    }

    showResult(data) {
        let popup = document.querySelector('#take-assessment-popup');
        const assessHint = popup.querySelector('.cg-popup__assess-hint');
        const {correctStatus, wrongStatus, answers} = l10n.customCourse;

        assessHint.innerHTML = `${correctStatus} ${answers}`;

        if (data.status) {
            if (popup.classList.contains('is-incorrect')) {
                popup.classList.remove('is-incorrect');
            }
            popup.classList.add('is-correct');
            popup.querySelector('.cg-popup__result').innerHTML = `
                <i class="cg-popup__status-icon"></i>
                <p class="cg-popup__status-label">${correctStatus}</p>
            `;
        } else {
            if (popup.classList.contains('is-correct')) {
                popup.classList.remove('is-correct');
            }
            popup.classList.add('is-incorrect');
            popup.querySelector('.cg-popup__result').innerHTML = `
                <i class="cg-popup__status-icon"></i>
                <p class="cg-popup__status-label">${wrongStatus}</p>
            `;
        }
        let items_list = popup.querySelector('.choice__list');
        let items = items_list.querySelectorAll('.choice__item');

        if (data.correctList) {
            popup.querySelector('.choice__header-item.is-correct-answer').classList.remove('is-hidden');
            for (let i = 0; i < items.length; i++) {
                items[i].querySelector('.choice__correct-answer').classList.remove('is-hidden');

                if (data.correctList.includes(items[i].querySelector('.choice__input').dataset.answer)) {
                    items[i].querySelector('.choice__correct-answer .choice__input-icon').classList.add('is-correct');
                } else {
                    const userAnswers = [...popup.querySelectorAll('.choice__input')];
                    const isCheckedInputsArray = userAnswers.map(input => input.checked);

                    if (isCheckedInputsArray[i]) {
                        userAnswers[i].parentElement.querySelector('.choice__input-icon').classList.add('is-incorrect');
                    }
                }
            }
        }
    }

}
